import axios from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Attach Cognito JWT on every request
const DEV_SKIP_AUTH = import.meta.env.DEV && import.meta.env.VITE_SKIP_AUTH === 'true'
const DEV_TOKEN = import.meta.env.VITE_DEV_TOKEN

api.interceptors.request.use(async (config) => {
  if (DEV_SKIP_AUTH && DEV_TOKEN) {
    config.headers.Authorization = `Bearer ${DEV_TOKEN}`
    return config
  }
  try {
    const session = await fetchAuthSession()
    const token = session.tokens?.idToken?.toString()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch {
    // Not authenticated — continue unauthenticated
  }
  return config
})

// Global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect on 401 for /users/me endpoint (unsigned users browsing ads)
    // Only redirect if explicitly navigating to protected pages
    if (error.response?.status === 401 && !DEV_SKIP_AUTH) {
      const requestUrl = error.config?.url || ''
      if (!requestUrl.includes('/users/me')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)
